import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Box } from '@chakra-ui/react';
import Select from 'react-select'

import { getCountryList } from '../features/railStations/railStationSlice'



export default function HomeCountrySelector({ setSelectedCountry, preselectedCountry, isDisabled }) {

    const { countries, isLoading } = useSelector((state) => state.stations)

    const dispatch = useDispatch()

    useEffect(() => {
        if (!isDisabled && (!countries || countries.length === 0))
            dispatch(getCountryList())
    }, [isDisabled])

    function handleCountrySelectChange(e) {
        setSelectedCountry({ 
            name: e.label,
            code: e.value 
        })
    }

    return (
        <Box minWidth='250px'>
            <Select
                placeholder={preselectedCountry ? preselectedCountry : "Select your home country"}
                isDisabled={isDisabled}
                isLoading={isLoading}
                options={countries}
                onChange={handleCountrySelectChange}
            />
        </Box>
    )
}
